import { extractApiErrorMessage } from './error-utils';

const DEFAULT_IMPORT_FAILURE_MESSAGE = 'Không thể nhập chứng từ. Vui lòng kiểm tra dữ liệu và thử lại.';
const DEFAULT_IMPORT_SUCCESS_MESSAGE = 'Đã nhập chứng từ từ Excel thành công';
const DEFAULT_IMPORT_PARTIAL_SUCCESS_MESSAGE = 'Đã nhập chứng từ từ Excel, một số chứng từ có lỗi';

export interface ImportBatchToastInput {
  hasError: boolean;
  totalCreated: number;
  totalFailed: number;
  firstError?: unknown;
  failureFallbackMessage?: string;
  successMessage?: string;
  partialSuccessMessage?: string;
}

export interface ImportBatchToast {
  description: string;
  variant: 'default' | 'destructive';
}

export const getImportBatchToast = ({
  hasError,
  totalCreated,
  totalFailed,
  firstError,
  failureFallbackMessage = DEFAULT_IMPORT_FAILURE_MESSAGE,
  successMessage = DEFAULT_IMPORT_SUCCESS_MESSAGE,
  partialSuccessMessage = DEFAULT_IMPORT_PARTIAL_SUCCESS_MESSAGE
}: ImportBatchToastInput): ImportBatchToast => {
  if (hasError && totalCreated === 0) {
    return {
      description: firstError
        ? extractApiErrorMessage({ data: firstError, fallbackMessage: failureFallbackMessage })
        : failureFallbackMessage,
      variant: 'destructive'
    };
  }

  return {
    description: totalFailed === 0 ? successMessage : partialSuccessMessage,
    variant: 'default'
  };
};
